module.exports = __webpack_public_path__ + "img/img_cno_tno.05171ed4.webp";